import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
import stl from "./AdSection.module.css";
import { useLang } from "@/common/Contexts/LanguageContext";
var AdSection = function AdSection() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var _useState = useState(false),
    ShowPopUp = _useState[0],
    setShowPopUp = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.outterContainer,
    id: "renewal-section-container"
  }, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("h3", {
    id: "renewal-section-title"
  }, t("repair_maintenance", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.imgsContainer,
    id: "renewal-images-container"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.spacer
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.singleImgContainerAD
  }, /*#__PURE__*/React.createElement("img", {
    className: stl.bbAd,
    src: CDN_LINK + "/assets/images/WashAndPolish.webp",
    alt: "wash and polish service",
    loading: "lazy",
    width: "255px",
    height: "298px"
  }), lang === "ar" ? /*#__PURE__*/React.createElement("img", {
    "data-dis": "ar",
    className: stl.whiteAd,
    src: CDN_LINK + "/assets/images/WashAndPolishAr.svg",
    alt: "Wash and polish service ad",
    loading: "lazy",
    width: "148px",
    height: "75px"
  }) : /*#__PURE__*/React.createElement("img", {
    "data-dis": "en",
    className: stl.whiteAd,
    src: CDN_LINK + "/assets/images/WashAndPolishEn.svg",
    alt: "Wash and polish service ad",
    loading: "lazy",
    width: "148px",
    height: "75px"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.singleImgContainerAD
  }, /*#__PURE__*/React.createElement("img", {
    className: stl.bbAd,
    src: CDN_LINK + "/assets/images/PaintInspection.webp",
    alt: "paint inspection service",
    loading: "lazy",
    width: "255px",
    height: "298px"
  }), lang === "ar" ? /*#__PURE__*/React.createElement("img", {
    "data-dis": "ar",
    className: stl.whiteAd,
    src: CDN_LINK + "/assets/images/PaintInspectionAr.svg",
    alt: "Paint inspection service ad",
    loading: "lazy",
    width: "148px",
    height: "75px"
  }) : /*#__PURE__*/React.createElement("img", {
    "data-dis": "en",
    className: stl.whiteAd,
    src: CDN_LINK + "/assets/images/PaintInspectionEn.svg",
    alt: "Paint inspection service ad",
    loading: "lazy",
    width: "148px",
    height: "75px"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.singleImgContainerAD
  }, /*#__PURE__*/React.createElement("img", {
    className: stl.bbAd,
    src: CDN_LINK + "/assets/images/PartsReplacement.webp",
    alt: "parts replacement service",
    loading: "lazy",
    width: "255px",
    height: "298px"
  }), lang === "ar" ? /*#__PURE__*/React.createElement("img", {
    "data-dis": "ar",
    className: stl.whiteAd,
    src: CDN_LINK + "/assets/images/PartsReplacementAr.svg",
    alt: "Parts replacement service ad",
    loading: "lazy",
    width: "148px",
    height: "75px"
  }) : /*#__PURE__*/React.createElement("img", {
    "data-dis": "en",
    className: stl.whiteAd,
    src: CDN_LINK + "/assets/images/PartsReplacementEn.svg",
    alt: "Parts replacement service ad",
    loading: "lazy",
    width: "148px",
    height: "75px"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.spacer
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.btnCont
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setShowPopUp(true);
    },
    id: "disclaimer-button"
  }, t("disclaimer", {
    ns: "web_post_view"
  }))))), /*#__PURE__*/React.createElement(SharedPopUp, {
    show: ShowPopUp,
    onClose: function onClose() {
      setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.ms2olyenPopUpCR
  }, /*#__PURE__*/React.createElement("strong", null, t("disclaimer", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("p", null, t("car_maintenance_repair_depend_condition", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("p", null, t("report_mean_way_adhere_condition", {
    ns: "web_post_view"
  })))));
};
export default AdSection;